<template>
  <v-card outlined>
    <v-list v-if="terms" class="list-250" :dense="$vuetify.breakpoint.xsOnly">
      <template v-for="(item, index) in terms">
        <v-list-item @click="termSelected(item)" :key="item.name">
          <v-list-item-content>
            <v-list-item-title class="text-capitalize">
              {{ item.name }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="index < terms.length - 1" :key="index"></v-divider>
      </template>
    </v-list>
  </v-card>

</template>

<script>
import termService from "@/modules/Terms/service.js";
export default {
  name: "term-list",
  data() {
    return {
      terms: [],
    };
  },
  created() {
    this.getList();
  },
  props: {
    YearId: {
      default: null,
    },
  },
  methods: {
    getList() {
      if (this.YearId) {
        return termService.getAll({ YearId: this.YearId }).then((response) => {
          console.log('response', response)
          this.terms = response.data;
          return response;
        }).catch(error => {
          console.log('error getting term', error)
        });
      }
    },
    termSelected(term) {
      this.$emit("termSelected", term);
    }
  },
};
</script>